export const theme = {
  colors: {
    primary: '#ff7000',
    secondary: 'brown',
    background: 'white',
    text: 'black',
    header: 'black'
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontLogo: '\'Mate SC\', serif;',
  fontHeader: '\'Playfair Display\', serif;',
  fontBody: '\'STIX Two Text\', serif'
}

//fontHeader: '\'Playfair Display\', serif;',
 // fontBody: '\'Mate\', serif;'